// extracted by mini-css-extract-plugin
export default {"wrapper":"NavBar_wrapper__WK1r9","link":"NavBar_link__uMlf6"};